import { Routes } from '@angular/router';
import { sessionGuard } from 'app/guards/session.guard';
import { unsavedChangesGuard } from 'app/guards/unsaved-changes.guard';

export const quotesRoutes: Routes = [
  {
    canActivate: [sessionGuard],
    data: { key: 'quotes' },
    loadComponent: () => import('./quotes/quotes.page').then((m) => m.QuotesPage),
    path: '',
  },
  {
    canActivate: [sessionGuard],
    canDeactivate: [unsavedChangesGuard],
    data: { key: 'quote-form' },
    loadComponent: () => import('./quote-form/quote-form.page').then((m) => m.QuoteFormPage),
    path: 'new',
  },
  {
    canActivate: [sessionGuard],
    data: { key: 'quote-configuration-preview' },
    loadComponent: () => import('./quote-configuration-preview/quote-configuration-preview.page').then((m) => m.QuoteConfigurationPreviewPage),
    path: 'configuration-preview',
  },
  {
    canActivate: [sessionGuard],
    data: { key: 'quote-details' },
    loadComponent: () => import('./quote-details/quote-details.page').then((m) => m.QuoteDetailsPage),
    path: ':quoteId',
  },
  {
    canActivate: [sessionGuard],
    canDeactivate: [unsavedChangesGuard],
    data: { key: 'quote-form' },
    loadComponent: () => import('./quote-form/quote-form.page').then((m) => m.QuoteFormPage),
    path: ':quoteId/edit',
  },
  {
    canActivate: [sessionGuard],
    data: { key: 'quote-preview' },
    loadComponent: () => import('./quote-preview/quote-preview.page').then((m) => m.QuotePreviewPage),
    path: ':quoteId/preview',
  },
  {
    canActivate: [sessionGuard],
    data: { key: 'quote-send-preview' },
    loadComponent: () => import('./quote-send-preview/quote-send-preview.page').then((m) => m.QuoteSendPreviewPage),
    path: ':quoteId/send-preview',
  },
];
